export default __webpack_public_path__ + "static/media/p2-img.f7f99648.png";